module.exports = __webpack_public_path__ + "static/media/imagecutout_addbackgroundcolor.4a044309.jpg";